export default __webpack_public_path__ + "static/media/catogorias_semanticas.74276f80.png";